// import cl from 'classnames'
  import {
    formatPrice, ImageSquare, PaginationButtons, SortDirection, TableBodyContainer,
    TableBodyLine,
    TableBodyLineProps, TableContainer,
    TableHeader,
    TableHeaderProps, Text1
  } from '@touche-lts/panel-ui/dist'
  import styles from './statistics-table.module.scss'
  import { observer } from 'mobx-react-lite'
  import { useRootStore } from 'mobx-stores/store-provider'
  import { StatisticsTableSortProps } from 'mobx-stores/utils'
  import { StatisticsTableEntryDTO } from 'models/statistics'
import { useEffect, useState } from 'react'
import _ from 'lodash';
import TableBody from './table-body'
import { getMyStoreProductViewPath } from 'routes'
  
  const StatisticsTableComponent = () => {
  
    const {
      routingStore: { push },
      userStore: { managementStoreId },
      statisticsTableStore: {
        isColumnMarked,
        getSortDirection,
        handleSortDirectionChange,
        searchProps,
        onSearchPropsChange,
        searchResults,
        // paginationInfo, // actiate if bd handles pagination in future
        // onPageSelect, // actiate if bd handles pagination in future
        setPaginationProps
      }
    } = useRootStore()

    useEffect(() => {
      if(searchResults) {
        console.log(searchResults)
        searchResults.forEach(store => {
          _.merge(store, store?.store)
        })
      }
    }, [searchResults]);

    const [pageSelected, setPageSelected] = useState(0); // define current page selected
    const [elementsPerPage, setElementsPerPage] = useState(10); // define elements per page

    const searchResultsPaginated = () => {
      const startIndexPage = pageSelected * elementsPerPage;
      return searchResults.slice(startIndexPage, startIndexPage + elementsPerPage)
    }

    const sortColumnTable = (sortVaue: StatisticsTableSortProps): void => {
      let sortDirection = getSortDirection(sortVaue);
      if(sortDirection === SortDirection.DESC) {
        sortDirection = SortDirection.ASC
      } else {
        sortDirection = SortDirection.DESC
      }
      setPaginationProps({
        sortProp: sortVaue,
        sortDirection
      } as any)
      if(sortDirection === SortDirection.DESC) {
        searchResults.sort((a, b) => a[sortVaue] - b[sortVaue]); 
      } else {
        searchResults.sort((a, b) => b[sortVaue] - a[sortVaue]); 
      }
    }

    const sortByName = (sortVaue: StatisticsTableSortProps): void => {
      let sortDirection = getSortDirection(sortVaue);
      if(sortDirection === SortDirection.DESC) {
        sortDirection = SortDirection.ASC
      } else {
        sortDirection = SortDirection.DESC
      }
      setPaginationProps({
        sortProp: sortVaue,
        sortDirection
      } as any)
      if(sortDirection === SortDirection.DESC) {
        searchResults.sort(function(a, b) {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      } else {
        searchResults.sort(function(a, b) {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        }); 
      }
    }
  
    const tableColumns: TableHeaderProps['tableColumns'] = [
      {
        label: 'product',
        isColumnMarked: isColumnMarked(StatisticsTableSortProps.PRODUCT_NAME),
        sortDirection: getSortDirection(StatisticsTableSortProps.PRODUCT_NAME),
        // setSortDirection: handleSortDirectionChange(
        //   StatisticsTableSortProps.PRODUCT_NAME
        // ), // actiate if bd handles pagination in future
        setSortDirection: () => sortByName(StatisticsTableSortProps.PRODUCT_NAME),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.productName,
          onChange: productName => onSearchPropsChange({ productName })
        }
      },
      {
        label: 'active skus',
        isColumnMarked: isColumnMarked(StatisticsTableSortProps.ACTIVE_SKUS),
        sortDirection: getSortDirection(StatisticsTableSortProps.ACTIVE_SKUS),
        // setSortDirection: handleSortDirectionChange(
        //   StatisticsTableSortProps.ACTIVE_SKUS
        // ), // actiate if bd handles pagination in future
        setSortDirection: () => sortColumnTable(StatisticsTableSortProps.ACTIVE_SKUS),
        sliderFilterProps: {
          label: 'active skus',
          min: 0,
          max: 100,
          value: [searchProps.activeSkusMin, searchProps.activeSkusMax],
          onChange: ([activeSkusMin, activeSkusMax]) =>
            onSearchPropsChange({ activeSkusMin, activeSkusMax })
        }
      },
      {
        label: 'inventory',
        isColumnMarked: isColumnMarked(StatisticsTableSortProps.INVENTORY),
        sortDirection: getSortDirection(StatisticsTableSortProps.INVENTORY),
        // setSortDirection: handleSortDirectionChange(
        //   StatisticsTableSortProps.INVENTORY
        // ), // actiate if bd handles pagination in future
        setSortDirection: () => sortColumnTable(StatisticsTableSortProps.INVENTORY),
        sliderFilterProps: {
          label: 'items in stock',
          min: 0,
          max: 100,
          value: [searchProps.stockMin, searchProps.stockMax],
          onChange: ([stockMin, stockMax]) =>
            onSearchPropsChange({ stockMin, stockMax })
        }
      },
      {
        label: 'sold',
        isColumnMarked: isColumnMarked(StatisticsTableSortProps.SOLD),
        sortDirection: getSortDirection(StatisticsTableSortProps.SOLD),
        // setSortDirection: handleSortDirectionChange(StatisticsTableSortProps.SOLD), // actiate if bd handles pagination in future
        setSortDirection: () => sortColumnTable(StatisticsTableSortProps.SOLD),
        sliderFilterProps: {
          label: 'items sold',
          min: 0,
          max: 100,
          value: [searchProps.soldMin, searchProps.soldMax],
          onChange: ([soldMin, soldMax]) =>
            onSearchPropsChange({ soldMin, soldMax })
        }
      },
      {
        label: 'revenue',
        isColumnMarked: isColumnMarked(StatisticsTableSortProps.REVENUE),
        sortDirection: getSortDirection(StatisticsTableSortProps.REVENUE),
        // setSortDirection: handleSortDirectionChange(
        //   StatisticsTableSortProps.REVENUE
        // ), // actiate if bd handles pagination in future
        setSortDirection: () => sortColumnTable(StatisticsTableSortProps.REVENUE),
        sliderFilterProps: {
          label: 'usd',
          min: 0,
          max: 100,
          value: [searchProps.minRevenue, searchProps.maxRevenue],
          onChange: ([minRevenue, maxRevenue]) =>
            onSearchPropsChange({ minRevenue, maxRevenue })
        }
      }
    ]
    // if (hideStoreColumn) {
    //   tableColumns.splice(2, 1)
    // }
  
    const getBodyLineCells = (
      store: StatisticsTableEntryDTO
    ): TableBodyLineProps['cells'] => {
      const cells: TableBodyLineProps['cells'] = [
        {
        //   widthPercentage: 100,
          children: (
            <>
              <ImageSquare src={store?.images[0]?.url} width={30} />
              <Text1
                colorPreset='dark'
                bold
                overflowEllipsis
                style={{ marginLeft: 8 }}
              >
                {store?.productName}
              </Text1>
            </>
          ),
          isColumnMarked: isColumnMarked(StatisticsTableSortProps.PRODUCT_NAME),
          onClick: () => push(getMyStoreProductViewPath((store as any).product.id, managementStoreId))
        },
        {
          children: store?.activeSkus, // TODO-A store.activeSkuCount
          isColumnMarked: isColumnMarked(StatisticsTableSortProps.ACTIVE_SKUS)
        },
        {
          children: (
            <div>
              <Text1 colorPreset='dark' overflowEllipsis>
                {store?.stock || 0} in stock
              </Text1>
              <Text1 colorPreset='dark' overflowEllipsis>
                ({store.variants || 0} variant
                {store.variants === 1 ? '' : 's'})
              </Text1>
            </div>
          ),
          isColumnMarked: isColumnMarked(StatisticsTableSortProps.INVENTORY)
        },
        {
          children: store?.sold || 0,
          isColumnMarked: isColumnMarked(StatisticsTableSortProps.SOLD)
        },
        {
          children: formatPrice(store?.revenueTotal),
          isColumnMarked: isColumnMarked(StatisticsTableSortProps.REVENUE)
        }
      ]
    //   if (hideStoreColumn) {
    //     cells.splice(2, 1)
    //   }
  
      return cells
    }
  
    return (
      <TableContainer className={styles.tableContainer} colorPreset='dark' {...{
        noBoxShadow: true,
        style: { marginTop: 15, minHeight: 230 }
      }}>
        <TableHeader colorPreset='dark' tableColumns={tableColumns} />
        <TableBodyContainer>
          <TableBody elements={searchResults} getBodyLineCells={getBodyLineCells} />
        </TableBodyContainer>
        {!!searchResults.length && (
          <PaginationButtons
            colorPreset='dark'
            alwaysShow
            totalPages={Math.ceil(searchResults.length / elementsPerPage)}
            selectedPageNumber={pageSelected}
            totalElements={searchResults.length}
            elementsPerPage={elementsPerPage}
            // {...paginationInfo} // actiate if bd handles pagination in future
            onPageSelect={(pageNumber) => {
              const e = document.getElementById("#top-row");
              e.scrollIntoView();
              setPageSelected(pageNumber);
              // onPageSelect(pageNumber) // actiate if bd handles pagination in future
            }}
          />
        )}
      </TableContainer>
    )
  }
  
  const StatisticsTable = observer(StatisticsTableComponent)
  export { StatisticsTable }
  